import React, {
  ChangeEvent,
  FC,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styles from "./FormExchanger.module.scss";
import MyButton from "../UI/MyButton/MyButton";
import MyInput from "../UI/MyInput/MyInput";
import { PUBLIC_ICON, PUBLIC_IMAGE } from "../../constants";
import FormBodyCryprtoBank from "./FormBodyCryprtoBank/FormBodyCryprtoBank";
import FormBodyCryptoCash from "./FormBodyCryptoCash/FormBodyCryptoCash";
import FormBodyCashCrypto from "./FormBodyCashCrypto/FormBodyCashCrypto";
import FormBodyBankCrypto from "./FormBodyBankCrypto/FormBodyBankCrypto";
import formStore from "../../stores/formStore";
import { JsonData } from "../../types/types";
import { observer } from "mobx-react-lite";
import FormBodyCryptoCrypto from "./FormBodyCryptoCrypto/FormBodyCryptoCrypto";
import poolsStore from "../../stores/poolsStore";
import { useNavigate } from "react-router";
import { PRESALE_ROUTE } from "../../utils/consts";
import MySpinner from "../UI/MySpinner/MySpinner";
import { MatrixCryptoBanner } from "../UI/MatrixCryptoBanner/MatrixCryptoBanner";
import ExchangeOffersPanel from "./ExchangeOffersPanel/ExchangeOffersPanel";

const FormExchanger: FC = observer(() => {
  const formHeaderImage = PUBLIC_IMAGE + "Main-logoImage.svg";
  const [selectedPay, setSelectedPay] = useState("");
  const [selectedReceive, setSelectedReceive] = useState("");
  const [loadingReceive, setLoadingReceive] = useState(false);
  const [loadingPay, setLoadingPay] = useState(false);
  const [openCurrencySelect, setOpenCurrencySelect] = useState<
    "pay" | "receive" | null
  >(null);
  const [paySearch, setPaySearch] = useState("");
  const [receiveSearch, setReceiveSearch] = useState("");
  const [payAmountDraft, setPayAmountDraft] = useState<string | null>(null);
  const navigate = useNavigate();
  const payTimer = useRef<NodeJS.Timeout | null>(null);
  const receiveTimer = useRef<NodeJS.Timeout | null>(null);
  const paySelectRef = useRef<HTMLDivElement | null>(null);
  const receiveSelectRef = useRef<HTMLDivElement | null>(null);
  let lastRequestId = 0;
  let isButtonClick = false;

  const jsonData: JsonData = {
    "Tether TRC20 (USDT)": {
      directions: {
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Tether TRC20 (USDT)",
      id: "10",
      type: "crypto",
      code: "USDT TRC20",
    },
    "BNB BEP20 (BNB)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "BNB BEP20 (BNB)",
      id: "19",
      type: "crypto",
      code: "BNB BEP20",
    },
    "XRP (XRP)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "XRP (XRP)",
      id: "161",
      type: "crypto",
      code: "XRP",
    },
    "Cardano (ADA)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Cardano (ADA)",
      id: "181",
      type: "crypto",
      code: "ADA",
    },
    "Polkadot (DOT)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Polkadot (DOT)",
      id: "201",
      type: "crypto",
      code: "DOT",
    },
    "Litecoin (LTC)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Litecoin (LTC)",
      id: "99",
      type: "crypto",
      code: "LTC",
    },
    "Monero (XMR)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Monero (XMR)",
      id: "149",
      type: "crypto",
      code: "XMR",
    },
    "Dogecoin (DOGE)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Dogecoin (DOGE)",
      id: "115",
      type: "crypto",
      code: "DOGE",
    },
    "TRON (TRX)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "TRON (TRX)",
      id: "185",
      type: "crypto",
      code: "TRX",
    },
    "Bitcoin Cash (BCH)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Bitcoin Cash (BCH)",
      id: "172",
      type: "crypto",
      code: "BCH",
    },
    "Stellar (XLM)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Stellar (XLM)",
      id: "182",
      type: "crypto",
      code: "XLM",
    },
    "Cosmos (ATOM)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Cosmos (ATOM)",
      id: "198",
      type: "crypto",
      code: "ATOM",
    },
    "Dash (DASH)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Dash (DASH)",
      id: "140",
      type: "crypto",
      code: "DASH",
    },
    "Bank card USD": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Bank card USD",
      id: "58",
      type: "bank",
      code: "CARDUSD",
    },
    "Bank card EUR": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Bank card EUR",
      id: "65",
      type: "bank",
      code: "CARDEUR",
    },
    "Bank card CAD": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Bank card CAD",
      id: "221",
      type: "bank",
      code: "CARDCAD",
    },
    "Cash USD": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Cash USD",
      id: "89",
      type: "cash",
      code: "CASHUSD",
    },
    "Ethereum (ETH)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Ethereum (ETH)",
      id: "139",
      type: "crypto",
      code: "ETH",
    },
    "Tether ERC20 (USDT)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Tether ERC20 (USDT)",
      id: "36",
      type: "crypto",
      code: "USDTERC20",
    },
    "USDC ERC20 (USDC)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "USDC ERC20 (USDC)",
      id: "23",
      type: "crypto",
      code: "USDCERC20",
    },
    "Wrapped BTC (WBTC)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Wrapped BTC (WBTC)",
      id: "73",
      type: "crypto",
      code: "WBTC",
    },
    "Dai (DAI)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Dai (DAI)",
      id: "203",
      type: "crypto",
      code: "DAI",
    },
    "Chainlink (LINK)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Chainlink (LINK)",
      id: "197",
      type: "crypto",
      code: "LINK",
    },
    "Zcash (ZEC)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Zcash (ZEC)",
      id: "162",
      type: "crypto",
      code: "ZEC",
    },
    "Yearn Finance (YFI)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Yearn Finance (YFI)",
      id: "220",
      type: "crypto",
      code: "YFI",
    },
    "SEPA EUR": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "SEPA EUR",
      id: "171",
      type: "bank",
      code: "SEPAEUR",
    },
    "BAT (BAT)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "BAT (BAT)",
      id: "61",
      type: "crypto",
      code: "BAT",
    },
    "EOS (EOS)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "EOS (EOS)",
      id: "178",
      type: "crypto",
      code: "EOS",
    },
    "Uniswap (UNI)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Uniswap (UNI)",
      id: "202",
      type: "crypto",
      code: "UNI",
    },
    "TrueUSD ERC20 (TUSD)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "TrueUSD ERC20 (TUSD)",
      id: "24",
      type: "crypto",
      code: "TUSDERC20",
    },
    "Pax Dollar (USDP)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Pax Dollar (USDP)",
      id: "189",
      type: "crypto",
      code: "USDP",
    },
    "Qtum (QTUM)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Qtum (QTUM)",
      id: "26",
      type: "crypto",
      code: "QTUM",
    },
    "0x (ZRX)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "0x (ZRX)",
      id: "168",
      type: "crypto",
      code: "ZRX",
    },
    "NEM (XEM)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "NEM (XEM)",
      id: "173",
      type: "crypto",
      code: "XEM",
    },
    "OMG Network (OMG)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "OMG Network (OMG)",
      id: "48",
      type: "crypto",
      code: "OMG",
    },
    "Maker (MKR)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Bitcoin (BTC)": {
          id: "93",
          name: "Bitcoin (BTC)",
          type: "crypto",
          code: "BTC",
        },
      },
      cur_name: "Maker (MKR)",
      id: "213",
      type: "crypto",
      code: "MKR",
    },
    "Bitcoin (BTC)": {
      directions: {
        "Tether TRC20 (USDT)": {
          id: "10",
          name: "Tether TRC20 (USDT)",
          type: "crypto",
          code: "USDT TRC20",
        },
        "BNB BEP20 (BNB)": {
          id: "19",
          name: "BNB BEP20 (BNB)",
          type: "crypto",
          code: "BNB BEP20",
        },
        "XRP (XRP)": {
          id: "161",
          name: "XRP (XRP)",
          type: "crypto",
          code: "XRP",
        },
        "Cardano (ADA)": {
          id: "181",
          name: "Cardano (ADA)",
          type: "crypto",
          code: "ADA",
        },
        "Polkadot (DOT)": {
          id: "201",
          name: "Polkadot (DOT)",
          type: "crypto",
          code: "DOT",
        },
        "Litecoin (LTC)": {
          id: "99",
          name: "Litecoin (LTC)",
          type: "crypto",
          code: "LTC",
        },
        "Monero (XMR)": {
          id: "149",
          name: "Monero (XMR)",
          type: "crypto",
          code: "XMR",
        },
        "Dogecoin (DOGE)": {
          id: "115",
          name: "Dogecoin (DOGE)",
          type: "crypto",
          code: "DOGE",
        },
        "TRON (TRX)": {
          id: "185",
          name: "TRON (TRX)",
          type: "crypto",
          code: "TRX",
        },
        "Bitcoin Cash (BCH)": {
          id: "172",
          name: "Bitcoin Cash (BCH)",
          type: "crypto",
          code: "BCH",
        },
        "Stellar (XLM)": {
          id: "182",
          name: "Stellar (XLM)",
          type: "crypto",
          code: "XLM",
        },
        "Cosmos (ATOM)": {
          id: "198",
          name: "Cosmos (ATOM)",
          type: "crypto",
          code: "ATOM",
        },
        "Dash (DASH)": {
          id: "140",
          name: "Dash (DASH)",
          type: "crypto",
          code: "DASH",
        },
        "Bank card USD": {
          id: "58",
          name: "Bank card USD",
          type: "bank",
          code: "CARDUSD",
        },
        "Bank card EUR": {
          id: "65",
          name: "Bank card EUR",
          type: "bank",
          code: "CARDEUR",
        },
        "Bank card CAD": {
          id: "221",
          name: "Bank card CAD",
          type: "bank",
          code: "CARDCAD",
        },
        "Cash USD": {
          id: "89",
          name: "Cash USD",
          type: "cash",
          code: "CASHUSD",
        },
        "Ethereum (ETH)": {
          id: "139",
          name: "Ethereum (ETH)",
          type: "crypto",
          code: "ETH",
        },
        "Tether ERC20 (USDT)": {
          id: "36",
          name: "Tether ERC20 (USDT)",
          type: "crypto",
          code: "USDTERC20",
        },
        "USDC ERC20 (USDC)": {
          id: "23",
          name: "USDC ERC20 (USDC)",
          type: "crypto",
          code: "USDCERC20",
        },
        "Wrapped BTC (WBTC)": {
          id: "73",
          name: "Wrapped BTC (WBTC)",
          type: "crypto",
          code: "WBTC",
        },
        "Dai (DAI)": {
          id: "203",
          name: "Dai (DAI)",
          type: "crypto",
          code: "DAI",
        },
        "Chainlink (LINK)": {
          id: "197",
          name: "Chainlink (LINK)",
          type: "crypto",
          code: "LINK",
        },
        "Zcash (ZEC)": {
          id: "162",
          name: "Zcash (ZEC)",
          type: "crypto",
          code: "ZEC",
        },
        "Yearn Finance (YFI)": {
          id: "220",
          name: "Yearn Finance (YFI)",
          type: "crypto",
          code: "YFI",
        },
        "SEPA EUR": {
          id: "171",
          name: "SEPA EUR",
          type: "bank",
          code: "SEPAEUR",
        },
        "BAT (BAT)": {
          id: "61",
          name: "BAT (BAT)",
          type: "crypto",
          code: "BAT",
        },
        "EOS (EOS)": {
          id: "178",
          name: "EOS (EOS)",
          type: "crypto",
          code: "EOS",
        },
        "Uniswap (UNI)": {
          id: "202",
          name: "Uniswap (UNI)",
          type: "crypto",
          code: "UNI",
        },
        "TrueUSD ERC20 (TUSD)": {
          id: "24",
          name: "TrueUSD ERC20 (TUSD)",
          type: "crypto",
          code: "TUSDERC20",
        },
        "Pax Dollar (USDP)": {
          id: "189",
          name: "Pax Dollar (USDP)",
          type: "crypto",
          code: "USDP",
        },
        "Qtum (QTUM)": {
          id: "26",
          name: "Qtum (QTUM)",
          type: "crypto",
          code: "QTUM",
        },
        "0x (ZRX)": {
          id: "168",
          name: "0x (ZRX)",
          type: "crypto",
          code: "ZRX",
        },
        "NEM (XEM)": {
          id: "173",
          name: "NEM (XEM)",
          type: "crypto",
          code: "XEM",
        },
        "OMG Network (OMG)": {
          id: "48",
          name: "OMG Network (OMG)",
          type: "crypto",
          code: "OMG",
        },
        "Maker (MKR)": {
          id: "213",
          name: "Maker (MKR)",
          type: "crypto",
          code: "MKR",
        },
      },
      cur_name: "Bitcoin (BTC)",
      id: "93",
      type: "crypto",
      code: "BTC",
    },
  };

  const payOptions = useMemo(() => Object.keys(jsonData), []);
  const receiveOptions = useMemo(() => {
    return selectedPay
      ? Object.keys(jsonData[selectedPay]?.directions || {})
      : [];
  }, [selectedPay]);
  const filterCurrencyOptions = (options: string[], query: string) => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return options;
    return options.filter((option) => {
      const code =
        jsonData[option]?.code ||
        jsonData[selectedPay]?.directions?.[option]?.code ||
        "";
      return `${option} ${code}`.toLowerCase().includes(normalizedQuery);
    });
  };
  const filteredPayOptions = useMemo(
    () => filterCurrencyOptions(payOptions, paySearch),
    [payOptions, paySearch]
  );
  const filteredReceiveOptions = useMemo(
    () => filterCurrencyOptions(receiveOptions, receiveSearch),
    [receiveOptions, receiveSearch, selectedPay]
  );

  const sendData = async () => {
    let newCourse = 0;
    try {
      const res = await fetch(
        "/api/v1/exchange/confirmation",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formStore.formData),
        }
      );

      if (!res.ok) {
        throw new Error(`Error server: ${res.status}`);
      }

      const result = await res.json();

      if (result.transactionId) {
        formStore.updateField("transactionId", result.transactionId);
      } else {
        console.warn("Transaction ID not found.");
      }

      formStore.updateFinalData("response", result);
    } catch (error) {
      console.error("err fetch-запроса confirm:", error);
    }
  };

  const looksLikeCryptoAddress = (address: string, assetLabel: string) => {
    const value = address.trim();
    const normalizedAsset = assetLabel.toLowerCase();

    if (!value || value.length < 24 || /\s/.test(value) || value.includes("@")) {
      return false;
    }

    if (normalizedAsset.includes("trx") || normalizedAsset.includes("tron")) {
      return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value);
    }

    if (
      normalizedAsset.includes("bnb") ||
      normalizedAsset.includes("eth") ||
      normalizedAsset.includes("erc20") ||
      normalizedAsset.includes("bep20")
    ) {
      return /^0x[a-fA-F0-9]{40}$/.test(value);
    }

    if (normalizedAsset.includes("btc") || normalizedAsset.includes("bitcoin")) {
      return /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,62}$/.test(value);
    }

    if (normalizedAsset.includes("xrp")) {
      return /^r[1-9A-HJ-NP-Za-km-z]{24,34}$/.test(value);
    }

    if (normalizedAsset.includes("sol")) {
      return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(value);
    }

    return /^[A-Za-z0-9]{24,120}$/.test(value);
  };

  const createAggregatorOrder = async () => {
    if (!formStore.formData.exchangeQuoteId) {
      alert("Select an exchange offer before continuing.");
      return false;
    }

    const recipientAddress = String(
      formStore.formData.btcWalletAddress || ""
    ).trim();

    if (
      !looksLikeCryptoAddress(
        recipientAddress,
        String(formStore.formData.receive || selectedReceive || "")
      )
    ) {
      formStore.invalidInputs = {
        ...formStore.invalidInputs,
        btcWalletAddress: true,
      };
      alert("Enter a valid recipient wallet address for the selected network.");
      return false;
    }

    try {
      const res = await fetch("/api/v1/exchange/orders", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          quote_id: formStore.formData.exchangeQuoteId,
          recipient_address: recipientAddress,
          email: formStore.formData.email,
          telegram: formStore.formData.telegram,
          captcha_token: formStore.captchaToken,
        }),
      });

      if (!res.ok) {
        throw new Error(`Order request failed: ${res.status}`);
      }

      const result = await res.json();
      formStore.updateField("transactionId", result.order_id || "");
      formStore.updateField("exchangeOrderId", result.order_id || "");
      formStore.updateField("exchangeOrderStatus", result.status || "");
      formStore.updateField("exchangeDepositAddress", result.deposit_address || "");
      formStore.updateFinalData("response", {
        ...result,
        transactionId: result.order_id,
        datetime: new Date().toLocaleString(),
      });

      if (!result.deposit_address) {
        alert(
          "This provider is in preview mode. No deposit address was issued yet."
        );
        return false;
      }

      return true;
    } catch (error) {
      console.error("err fetch-запроса exchange order:", error);
      alert("Exchange order is temporarily unavailable.");
      return false;
    }
  };

  useEffect(() => {
    if (payOptions.length > 0 && !selectedPay) {
      const defaultPay = payOptions[0];
      setSelectedPay(defaultPay);
      formStore.updateField("pay", defaultPay);
      formStore.updateField("payId", jsonData[defaultPay].id);
      formStore.updateForm("pay", defaultPay);
      formStore.updateForm("payId", jsonData[defaultPay].id);
      formStore.updateFormReceive("pay", defaultPay);
      formStore.updateFormReceive("payId", jsonData[defaultPay].id);
      console.log("Полученный курс", formStore.formConvert);
    }
  }, [payOptions]);

  useEffect(() => {
    if (selectedPay && receiveOptions.length > 0 && !selectedReceive) {
      const defaultReceive = receiveOptions[0];
      setSelectedReceive(defaultReceive);
      formStore.updateField("receive", defaultReceive);
      formStore.updateField("receiveId", jsonData[defaultReceive].id);
      formStore.updateForm("receive", defaultReceive);
      formStore.updateForm("receiveId", jsonData[defaultReceive].id);
      formStore.updateFormReceive("receive", defaultReceive);
      formStore.updateFormReceive("receiveId", jsonData[defaultReceive].id);
      console.log("Полученный курс", formStore.formConvert);
    }
  }, [selectedPay, receiveOptions]);

  useEffect(() => {
    const handleDocumentMouseDown = (event: MouseEvent) => {
      const target = event.target as Node;
      if (
        paySelectRef.current?.contains(target) ||
        receiveSelectRef.current?.contains(target)
      ) {
        return;
      }
      setOpenCurrencySelect(null);
    };

    document.addEventListener("mousedown", handleDocumentMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleDocumentMouseDown);
    };
  }, []);

  // const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = event.target;
  //   formStore.updateField(name, value);
  // };

  const scrollToTop = () => {
    const offset = (window.innerHeight * 19) / 100;
    window.scrollTo({ top: offset, behavior: "smooth" });
  };

  const handlePaySelect = async (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setPayAmountDraft(value);
    formStore.updateField(name, value);
    formStore.updateForm("payValue", value);
    formStore.updateForm("paySelect", value);

    if (payTimer.current) clearTimeout(payTimer.current);

    payTimer.current = setTimeout(async () => {
      const requestId = ++lastRequestId;
      setLoadingReceive(true);

      try {
        if (formStore.activeComponent === "crypto-crypto") {
          formStore.setSelectedExchangeQuote(null);
          formStore.updateFormConvert({});
          formStore.newCourse = 0;
          formStore.setIsLoading(true);
          return;
        }
        await formStore.getCourse();
      } finally {
        setLoadingReceive(false);
      }
    }, 300);
  };

  // const handlePaySelect = async (event: ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = event.target;
  //   await formStore.updateField(name, value);
  //   await formStore.updateForm("payValue", value);
  //   await formStore.updateForm("paySelect", value);
  //   await formStore.getCourse();
  // };

  const handleReceiveSelect = async (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    formStore.updateField(name, value);
    formStore.updateFormReceive("receiveValue", value);
    formStore.updateFormReceive("receiveSelect", value);
    if (receiveTimer.current) clearTimeout(receiveTimer.current);

    receiveTimer.current = setTimeout(async () => {
      const requestId = ++lastRequestId;
      setLoadingPay(true);

      try {
        if (formStore.activeComponent === "crypto-crypto") {
          formStore.setSelectedExchangeQuote(null);
          formStore.updateFormConvert({});
          formStore.newCourse = 0;
          formStore.setIsLoading(true);
          return;
        }
        await formStore.getCourseReceive();
      } finally {
        setLoadingPay(false);
      }
    }, 300);
  };

  const handlePaySelectChange = async (value: string) => {
    setPayAmountDraft("");
    formStore.updateField("payValue", "");
    formStore.updateForm("payValue", "");
    formStore.updateForm("paySelect", "");
    formStore.updateFormReceive("paySelect", "");
    formStore.updateField("receiveValue", "");
    formStore.updateForm("receiveSelect", "");
    formStore.updateFormReceive("payValue", "");
    formStore.updateFormReceive("receiveSelect", "");
    formStore.updateField("paySelect", "");
    formStore.updateField("receiveSelect", "");
    const name = "pay";
    const selectedPay = jsonData[value];
    setOpenCurrencySelect(null);
    setPaySearch("");
    setReceiveSearch("");
    setSelectedPay(value);
    formStore.updateField(name, value);
    formStore.updateField("payId", selectedPay.id);
    formStore.updateForm(name, value);
    formStore.updateForm("payId", selectedPay.id);
    formStore.updateFormReceive(name, value);
    formStore.updateFormReceive("payId", selectedPay.id);

    const firstReceiveOption = Object.keys(jsonData[value]?.directions)[0];
    const firstReceiveType = jsonData[firstReceiveOption].type;
    setSelectedReceive(firstReceiveOption);
    formStore.updateField("receive", firstReceiveOption);
    formStore.updateForm("receive", firstReceiveOption);
    formStore.updateFormReceive("receive", firstReceiveOption);
    formStore.updateField("receiveId", jsonData[firstReceiveOption].id);
    formStore.updateForm("receiveId", jsonData[firstReceiveOption].id);
    formStore.updateFormReceive("receiveId", jsonData[firstReceiveOption].id);

    let activeComponent = "";
    let direction = "";
    let directionReceive = "";

    if (firstReceiveType === "crypto" && selectedPay.type === "cash") {
      activeComponent = "cash-crypto";
      direction = "cash-crypto";
      directionReceive = "crypto-cash";
    } else if (firstReceiveType === "cash" && selectedPay.type === "crypto") {
      activeComponent = "crypto-cash";
      direction = "crypto-cash";
      directionReceive = "cash-crypto";
    } else if (firstReceiveType === "bank" && selectedPay.type === "crypto") {
      activeComponent = "crypto-bank";
      direction = "crypto-bank";
      directionReceive = "bank-crypto";
    } else if (firstReceiveType === "crypto" && selectedPay.type === "bank") {
      activeComponent = "bank-crypto";
      direction = "bank-crypto";
      directionReceive = "crypto-bank";
    } else if (firstReceiveType === "crypto" && selectedPay.type === "crypto") {
      activeComponent = "crypto-crypto";
      direction = "crypto-crypto";
      directionReceive = "crypto-crypto";
    }

    if (activeComponent && direction) {
      formStore.setActiveComponent(activeComponent);
      formStore.updateField("direction", direction);
      formStore.updateForm("direction", direction);
      formStore.updateFormReceive("direction", directionReceive);
    }
    if (activeComponent === "crypto-crypto") {
      formStore.setSelectedExchangeQuote(null);
      formStore.updateFormConvert({});
      formStore.newCourse = 0;
      formStore.setIsLoading(true);
    } else {
      formStore.getCourse();
    }
    console.log("Полученный курс", formStore.formConvert);
  };

  const handleReceiveSelectChange = async (value: string) => {
    const currentPayAmount = String(
      payAmountDraft ??
        (formStore.formData.paySelect || formStore.formCourse.paySelect || "")
    );
    setPayAmountDraft(currentPayAmount);
    formStore.updateForm("payValue", currentPayAmount);
    formStore.updateForm("paySelect", currentPayAmount);
    formStore.updateFormReceive("paySelect", currentPayAmount);
    formStore.updateForm("receiveSelect", "");
    formStore.updateFormReceive("payValue", currentPayAmount);
    formStore.updateFormReceive("receiveSelect", "");
    formStore.updateField("receiveSelect", "");
    const name = "receive";
    formStore.updateField(name, value);
    setOpenCurrencySelect(null);
    setReceiveSearch("");
    setSelectedReceive(value);
    const selectedDirection = jsonData[selectedPay]?.directions[value];
    formStore.updateField("receiveId", selectedDirection.id);
    formStore.updateForm("receiveId", selectedDirection.id);

    if (selectedDirection) {
      setSelectedReceive(value);

      let activeComponent = "";
      let direction = "";
      let directionReceive = "";

      if (
        selectedDirection.type === "crypto" &&
        jsonData[selectedPay].type === "cash"
      ) {
        activeComponent = "cash-crypto";
        direction = "cash-crypto";
        directionReceive = "crypto-cash";
      } else if (
        selectedDirection.type === "cash" &&
        jsonData[selectedPay].type === "crypto"
      ) {
        activeComponent = "crypto-cash";
        direction = "crypto-cash";
        directionReceive = "cash-crypto";
      } else if (
        selectedDirection.type === "bank" &&
        jsonData[selectedPay].type === "crypto"
      ) {
        activeComponent = "crypto-bank";
        direction = "crypto-bank";
        directionReceive = "bank-crypto";
      } else if (
        selectedDirection.type === "crypto" &&
        jsonData[selectedPay].type === "bank"
      ) {
        activeComponent = "bank-crypto";
        direction = "bank-crypto";
        directionReceive = "crypto-bank";
      } else if (
        selectedDirection.type === "crypto" &&
        jsonData[selectedPay].type === "crypto"
      ) {
        activeComponent = "crypto-crypto";
        direction = "crypto-crypto";
        directionReceive = "crypto-crypto";
      }

      if (activeComponent && direction) {
        formStore.setActiveComponent(activeComponent);
        formStore.updateField("direction", direction);
        formStore.updateForm("direction", direction);
        formStore.updateFormReceive("direction", directionReceive);
      }
      if (activeComponent === "crypto-crypto") {
        formStore.setSelectedExchangeQuote(null);
        formStore.updateFormConvert({});
        formStore.newCourse = 0;
        formStore.setIsLoading(true);
      } else {
        formStore.getCourse();
      }
    }
  };

  const formatProviderLimit = (value: unknown) => {
    if (value === null || value === undefined || value === "") return undefined;
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return undefined;
    return String(numeric);
  };

  const formatDisplayNumber = (
    value: unknown,
    digits = 5,
    fallback = "N/A"
  ) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return fallback;
    return numeric.toFixed(digits).replace(/\.?0+$/, "");
  };

  const hasDisplayNumber = (value: unknown) => {
    const numeric = Number(value);
    return Number.isFinite(numeric) && numeric > 0;
  };

  const handleAggregatorQuoteSelect = (quote: { [key: string]: any }) => {
    const receiveAmount = String(quote.receive_amount || "");
    const raw = quote.raw || {};
    const fromLimits = raw.limits?.from || {};
    const providerMin = formatProviderLimit(fromLimits.min);
    const providerMax = formatProviderLimit(fromLimits.max);
    const rate = formatProviderLimit(quote.rate);
    const receiveMin =
      providerMin && rate ? String(Number(providerMin) * Number(rate)) : "";
    const receiveMax =
      providerMax && rate ? String(Number(providerMax) * Number(rate)) : "";

    formStore.setSelectedExchangeQuote(quote);
    formStore.updateField("receiveSelect", receiveAmount);
    formStore.updateFormReceive("receiveSelect", receiveAmount);
    formStore.updateFormReceive("receiveValue", receiveAmount);
    formStore.updateFormConvert({
      ...formStore.formConvert,
      xxx_rate: rate || "",
      rate_format: rate || "",
      l_min: providerMin || "",
      l_max: providerMax || "",
      r_min: receiveMin,
      r_max: receiveMax,
    });
    formStore.newCourse = rate ? Number(rate) : 0;
    formStore.setIsLoading(false);
  };

  const getCurrencyIconName = (option: string, mode: "pay" | "receive") => {
    if (mode === "pay") return jsonData[option]?.cur_name || option;
    return jsonData[selectedPay]?.directions?.[option]?.name || option;
  };

  const getSelectedCurrencyLabel = (option: string, mode: "pay" | "receive") => {
    if (!option) return "Select currency";
    if (mode === "pay") return jsonData[option]?.code || option;
    return jsonData[selectedPay]?.directions?.[option]?.code || option;
  };

  const renderCurrencySelect = ({
    mode,
    value,
    options,
    search,
    setSearch,
    onSelect,
    disabled = false,
  }: {
    mode: "pay" | "receive";
    value: string;
    options: string[];
    search: string;
    setSearch: (value: string) => void;
    onSelect: (value: string) => void;
    disabled?: boolean;
  }) => {
    const isOpen = openCurrencySelect === mode;
    const selectedIconName = value ? getCurrencyIconName(value, mode) : "default";
    const ref = mode === "pay" ? paySelectRef : receiveSelectRef;

    return (
      <div
        className={`${styles.currencySelect} ${
          isOpen ? styles.currencySelectOpen : ""
        }`}
        ref={ref}
      >
        <button
          type="button"
          className={`${styles.currencySelect__button} ${
            disabled ? styles.currencySelect__buttonDisabled : ""
          }`}
          disabled={disabled}
          onClick={() =>
            setOpenCurrencySelect((current) => (current === mode ? null : mode))
          }
        >
          <img
            src={`${PUBLIC_ICON}${selectedIconName}.svg`}
            alt=""
            className={styles.currencySelect__icon}
            onError={(event) => {
              event.currentTarget.src = `${PUBLIC_ICON}default.svg`;
            }}
          />
          <span>{getSelectedCurrencyLabel(value, mode)}</span>
          <img
            src={PUBLIC_IMAGE + "arrowRight.svg"}
            alt=""
            className={`${styles.currencySelect__arrow} ${
              isOpen ? styles.currencySelect__arrowOpen : ""
            }`}
          />
        </button>

        {isOpen && (
          <div className={styles.currencySelect__menu}>
            <input
              className={styles.currencySelect__search}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search"
              autoFocus
            />
            <div className={styles.currencySelect__list}>
              {options.length === 0 && (
                <div className={styles.currencySelect__empty}>No matches</div>
              )}
              {options.map((option) => {
                const iconName = getCurrencyIconName(option, mode);
                return (
                  <button
                    type="button"
                    key={option}
                    className={`${styles.currencySelect__option} ${
                      option === value ? styles.currencySelect__optionActive : ""
                    }`}
                    onClick={() => onSelect(option)}
                  >
                    <img
                      src={`${PUBLIC_ICON}${iconName}.svg`}
                      alt=""
                      onError={(event) => {
                        event.currentTarget.src = `${PUBLIC_ICON}default.svg`;
                      }}
                    />
                    <span>{option}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleSubmit = async () => {
    isButtonClick = true;
    const validationResult = formStore.validateFields();

    if (validationResult) {
      poolsStore.setIsSubscribe(false);

      if (
        formStore.activeComponent === "crypto-crypto" &&
        formStore.formData.exchangeQuoteId
      ) {
        const orderCreated = await createAggregatorOrder();
        if (!orderCreated) {
          formStore.setDataValid(undefined);
          return;
        }
      } else {
        await sendData();
      }

      formStore.setDataValid(true);
      formStore.setIsPaid(0);
      scrollToTop();
    } else {
      formStore.dataValid = false;
    }
  };

  return (
    <div className={styles.form__exchanger}>
      <div className={styles.information__line}>
        <div className={styles.information__lightBox}></div>
        <div className={styles.main__informationLogo}>
          <img src={formHeaderImage} alt="" />
        </div>
      </div>
      <div className={styles.form__wrapper}>
        <div className={styles.form__header}>
          <div
            className={
              formStore.hitsSteps === 1
                ? `${styles.pay__wrapper} ${styles.pay__wrapperActive}`
                : styles.pay__wrapper
            }
          >
            <div className={styles.form__headerPay}>Pay</div>
            <div className={styles.form__headerPayLine}></div>
            <div className={styles.form__pay}>
              <div className={styles.form__payValue}>
                {renderCurrencySelect({
                  mode: "pay",
                  value: selectedPay,
                  options: filteredPayOptions,
                  search: paySearch,
                  setSearch: setPaySearch,
                  onSelect: handlePaySelectChange,
                })}
                {loadingPay ? (
                  <div className={styles.form__spinnerWrapper}>
                    {" "}
                    <MySpinner />
                  </div>
                ) : (
                  <MyInput
                    name="paySelect"
                    className={styles.form__payInputValue}
                    onChange={handlePaySelect}
                    placeHolder="0"
                    isInvalid={formStore.invalidInputs.paySelect}
                    value={
                      payAmountDraft ??
                      String(
                        formStore.formCourse.paySelect ||
                          formStore.formData.paySelect ||
                          ""
                      )
                    }
                  />
                )}
              </div>
              <div className={styles.form__payBottomInput}>
                <div
                  className={
                    formStore.formData.paySelect === "" ||
                    formStore.formData.receiveSelect === ""
                      ? styles.form__payExchangeRateNone
                      : styles.form__payExchangeRate
                  }
                >
                  Exchange rate
                  <div className={styles.form__payExchangeRateText}>
                    1 {jsonData[selectedPay]?.code} ={" "}
                    {formStore.isLoading
                      ? "Loading"
                      : !formStore.newCourse || formStore.newCourse == 0
                      ? "There is no exchange rate"
                      : formatDisplayNumber(
                          formStore.formConvert.xxx_rate,
                          8,
                          "There is no exchange rate"
                        )}{" "}
                    {jsonData[selectedPay]?.directions[selectedReceive]?.code}
                  </div>
                </div>
                <div className={styles.form__payLimits}>
                  {loadingReceive || loadingPay ? (
                    <MySpinner />
                  ) : (
                    <>
                      <div className={styles.from__payInputWarning}>
                        <div
                          className={
                            formStore.validatePaySelectMin &&
                            hasDisplayNumber(formStore.formConvert.l_min)
                              ? styles.from__payInputWarningMin
                              : styles.from__payInputWarningMinNone
                          }
                        >
                          min.:{" "}
                          {formStore.isLoading
                            ? "Loading"
                            : formatDisplayNumber(
                                formStore.formConvert.l_min
                              )}{" "}
                          {jsonData[selectedPay]?.code}
                        </div>
                        <div
                          className={
                            formStore.validatePaySelectMax &&
                            hasDisplayNumber(formStore.formConvert.l_max)
                              ? styles.from__payInputWarningMax
                              : styles.from__payInputWarningMaxNone
                          }
                        >
                          max.:{" "}
                          {formStore.isLoading
                            ? "Loading"
                            : formatDisplayNumber(
                                formStore.formConvert.l_max
                              )}{" "}
                          {jsonData[selectedPay]?.code}
                        </div>
                      </div>
                      <div
                        className={
                          formStore.formData.paySelect === "" ||
                          formStore.formData.receiveSelect === "" ||
                          !hasDisplayNumber(formStore.formConvert.l_min)
                            ? styles.form__iminExchangerNone
                            : styles.form__iminExchanger
                        }
                      >
                        min.:{" "}
                        {formStore.isLoading
                          ? "Loading"
                          : formatDisplayNumber(formStore.formConvert.l_min)}{" "}
                        {jsonData[selectedPay]?.code}
                      </div>
                      <div
                        className={
                          formStore.formData.paySelect === "" ||
                          formStore.formData.receiveSelect === "" ||
                          !hasDisplayNumber(formStore.formConvert.l_max)
                            ? styles.form__iminExchangerNone
                            : styles.form__iminExchanger
                        }
                      >
                        max.:{" "}
                        {formStore.isLoading
                          ? "Loading"
                          : formatDisplayNumber(formStore.formConvert.l_max)}{" "}
                        {jsonData[selectedPay]?.code}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.form__headerLine}></div>
          <div className={styles.form__headerLine2}></div>
          <div className={styles.form__headerLine3}></div>
          <div
            className={
              formStore.hitsSteps === 2
                ? `${styles.receive__wrapperActive} ${styles.receive__wrapper}`
                : styles.receive__wrapper
            }
          >
            <div className={styles.form__headerReceiveLine}></div>
            <div className={styles.form__headerReceive}>Receive</div>
            <div className={styles.form__headerReceiveLine}></div>
            <div className={styles.form__receive}>
              <div className={styles.form__receiveValue}>
                {renderCurrencySelect({
                  mode: "receive",
                  value: selectedReceive,
                  options: filteredReceiveOptions,
                  search: receiveSearch,
                  setSearch: setReceiveSearch,
                  onSelect: handleReceiveSelectChange,
                  disabled: !selectedPay,
                })}
                {loadingReceive ? (
                  <div className={styles.form__spinnerWrapper}>
                    {" "}
                    <MySpinner />
                  </div>
                ) : (
                  <MyInput
                    name="receiveSelect"
                    className={styles.form__receiveInputValue}
                    onChange={handleReceiveSelect}
                    placeHolder="0"
                    value={
                      loadingReceive ? (
                        <MySpinner />
                      ) : (
                        formStore.formCourseReceive.receiveSelect
                      )
                    }
                    isInvalid={formStore.invalidInputs.receiveSelect}
                  />
                )}
              </div>
              <div className={styles.form__receiveLimits}>
                {loadingReceive || loadingPay ? (
                  <MySpinner />
                ) : (
                  <>
                    <div className={styles.form__receiveInputWarning}>
                      <div
                        className={
                          formStore.validateReceiveSelectMax
                            && hasDisplayNumber(formStore.formConvert.r_max)
                            ? styles.form__receiveInputWarningMax
                            : styles.form__receiveInputWarningMaxNone
                        }
                      >
                        <div
                          className={
                            formStore.validateReceiveSelectMax
                              && hasDisplayNumber(formStore.formConvert.r_max)
                              ? styles.form__iminExchanger
                              : styles.form__iminExchangerNone
                          }
                        >
                          max.:{" "}
                          {formStore.isLoading
                            ? "Loading"
                            : formatDisplayNumber(
                                formStore.formConvert.r_max
                              )}{" "}
                          {
                            jsonData[selectedPay]?.directions[selectedReceive]
                              ?.code
                          }
                        </div>
                      </div>
                      <div
                        className={
                          formStore.validateReceiveSelectMin
                            && hasDisplayNumber(formStore.formConvert.r_min)
                            ? styles.form__receiveInputWarningMin
                            : styles.form__receiveInputWarningMinNone
                        }
                      >
                        <div>
                          min.:{" "}
                          {formStore.isLoading
                            ? "Loading"
                            : formatDisplayNumber(
                                formStore.formConvert.r_min
                              )}{" "}
                          {
                            jsonData[selectedPay]?.directions[selectedReceive]
                              ?.code
                          }
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        formStore.formData.paySelect === "" ||
                        formStore.formData.receiveSelect === "" ||
                        !hasDisplayNumber(formStore.formConvert.r_min)
                          ? styles.form__iminExchangerNone
                          : styles.form__iminExchanger
                      }
                    >
                      min.:{" "}
                      {formStore.isLoading
                        ? "Loading"
                        : formatDisplayNumber(formStore.formConvert.r_min)}{" "}
                      {jsonData[selectedPay]?.directions[selectedReceive]?.code}
                    </div>
                    <div
                      className={
                        formStore.formData.paySelect === "" ||
                        formStore.formData.receiveSelect === "" ||
                        !hasDisplayNumber(formStore.formConvert.r_max)
                          ? styles.form__iminExchangerNone
                          : styles.form__iminExchanger
                      }
                    >
                      max.:{" "}
                      {formStore.isLoading
                        ? "Loading"
                        : formatDisplayNumber(formStore.formConvert.r_max)}{" "}
                      {jsonData[selectedPay]?.directions[selectedReceive]?.code}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.form__body}></div>
        <ExchangeOffersPanel
          activeComponent={formStore.activeComponent}
          selectedPay={selectedPay}
          selectedReceive={selectedReceive}
          payAmount={String(
            payAmountDraft ??
              (formStore.formCourse.paySelect || formStore.formData.paySelect || "")
          )}
          fromCode={jsonData[selectedPay]?.code}
          toCode={jsonData[selectedPay]?.directions[selectedReceive]?.code}
          selectedQuoteId={formStore.selectedExchangeQuote?.quote_id}
          onQuoteSelect={handleAggregatorQuoteSelect}
          onLoadingChange={(isLoading) => formStore.setIsLoading(isLoading)}
        />
        {formStore.activeComponent === "cash-crypto" && <FormBodyCashCrypto />}
        {formStore.activeComponent === "bank-crypto" && <FormBodyBankCrypto />}
        {formStore.activeComponent === "crypto-bank" && <FormBodyCryprtoBank />}
        {formStore.activeComponent === "crypto-cash" && <FormBodyCryptoCash />}
        {formStore.activeComponent === "crypto-crypto" && (
          <FormBodyCryptoCrypto />
        )}
      </div>
      <div data-exchange-submit>
        <MyButton onClick={handleSubmit} className={formStore.hitsSteps === 4 ? `${styles.form__button} ${styles.form__buttonActive}`: styles.form__button}>
          EXCHANGE
        </MyButton>
      </div>
      {/* <MyButton
        onClick={() => navigate(PRESALE_ROUTE)}
        className={styles.form__button}
      >
        EXCHANGE
      </MyButton> */}
      <div
        className={`${
          formStore.activeComponent === "cashCrypto" &&
          formStore.invalidInputs.paySelect
            ? styles.form__formBottomText
            : styles.form__formBottomTextNone
        }`}
      >
        The amount of cash must be at least $ 150,00
      </div>
      <div className={styles.form__bottomLine}>
        <div className={styles.form__externalLine}>
          <div className={styles.form__externalInsideLine}></div>
        </div>
      </div>
    </div>
  );
});

export default FormExchanger;
